module.exports = __webpack_public_path__ + "6e23b94833cde84c65dca215d8710bcf.jpg";